import { Dispatch } from 'redux';
import { ICountryMap } from '../../app/common/fields/country/country';
import { SupportedLanguage } from '../../config/constants/supportedLanguage.enum';
import { CountriesActionType } from './countriesActionType';

export class CountriesActions {
    public static retrieveCountries(lang: SupportedLanguage) {
        const request = () => ({
            type: CountriesActionType.GET_COUNTRIES_REQUEST,
        });

        const resolveSuccess = (countries: ICountryMap) => ({
            payload: { lang, countries },
            type: CountriesActionType.GET_COUNTRIES_SUCCESS,
        });

        const resolveError = () => ({
            payload: {},
            type: CountriesActionType.GET_COUNTRIES_FAILURE,
        });

        return (dispatch: Dispatch<CountriesActions>) => {
            dispatch(request());

            return import(`./countries-${lang.toLowerCase()}.json`)
                .then((countriesModule) => {
                    dispatch(resolveSuccess(countriesModule.default));
                })
                .catch(() => dispatch(resolveError()));
        };
    }
}
